import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import services from "../services";

interface AllHistoryLogsState {
  data: any[];
  total: number;
  loading: boolean;
  error: boolean;
}

const initialState: AllHistoryLogsState = {
  data: [],
  total: 0,
  loading: false,
  error: false,
};

const AllHistoryLogsSlice = createSlice({
  name: "allHistoryLogs",
  initialState,
  reducers: {
    getAllHistoryLogs: (state) => {
      state.loading = true;
      state.error = false;
      state.data = [];
      state.total = 0;
    },
    getAllHistoryLogsSuccess: (state, action: PayloadAction<{ results: any[]; count: number }>) => {
      state.loading = false;
      state.error = false;
      state.data = action.payload.results;
      state.total = action.payload.count;
    },
    getAllHistoryLogsFailure: (state) => {
      state.loading = false;
      state.error = true;
      state.data = [];
      state.total = 0;
    },
  },
});

export const { getAllHistoryLogs, getAllHistoryLogsSuccess, getAllHistoryLogsFailure } =
  AllHistoryLogsSlice.actions;

export default AllHistoryLogsSlice.reducer;

export const fetchAllHistoryLogs =
  (filters: any, page?: string) =>
  async (dispatch: any) => {
    dispatch(getAllHistoryLogs());
    try {
      const response = await services.getAllHistoryLogs(filters, page);

      if (response && response.results) {
        dispatch(getAllHistoryLogsSuccess({
          results: response.results,
          count: response.count,
        }));
      } else {
        dispatch(getAllHistoryLogsFailure());
      }
    } catch (err) {
      console.error("Erro ao buscar histórico:", err);
      dispatch(getAllHistoryLogsFailure());
    }
  };

